/* eslint-disable consistent-return */
import { useState, useContext, useEffect } from 'react';

import { useMutation } from '@apollo/client';
import axios from 'axios';

import config from '../../../config';
import { GeneralContext } from '../../../core/app-context/GeneralContext';
import { DELETE_FILE_BY_URL } from './graphql';
import AuthService from '../../../core/auth/AuthService';

export function useFileUploader() {
  const { setErrorMessage, setLoading, setSuccessMessage } =
    useContext(GeneralContext);
  const [isLoading, setIsLoading] = useState(false);
  const [DeleteFileByUrlMutation, { loading: graphqlLoading }] =
    useMutation(DELETE_FILE_BY_URL);

  useEffect(() => {
    setLoading(isLoading || graphqlLoading);
  }, [isLoading, graphqlLoading]);

  async function uploadFile(file) {
    try {
      setIsLoading(true);
      const formData = new FormData();
      formData.append('File', file);
      const response = await axios.post(config.fileUploadUrl, formData, {
        headers: {
          'accept-language': 'pt-BR',
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${AuthService.getToken()}`,
        },
      });
      if (response.status === 200) {
        return response.data.fileUrl;
      }
      setErrorMessage('Falha ao salvar a imagem. Tente novamente.');
      return null;
    } catch (err) {
      setErrorMessage('Falha ao salvar a imagem. Tente novamente.');
    } finally {
      setIsLoading(false);
    }
  }

  async function deleteFile(storeId, url) {
    try {
      const res = await DeleteFileByUrlMutation({
        variables: { storeId, url },
      });
      if (res.data.deleteFileByUrl.code === 200) {
        setSuccessMessage(res.data.deleteFileByUrl.message);
      } else {
        setErrorMessage(res.data.deleteFileByUrl.message);
      }
    } catch (err) {
      setErrorMessage('Falha ao salvar a imagem. Tente novamente.');
    } finally {
      setLoading(false);
    }
  }

  return { uploadFile, deleteFile, loading: isLoading };
}
